import Component from 'core/Component';
import { on, off } from 'toolbox/event';
import { deepMerge } from 'toolbox/deepMerge';
import { Event } from 'services/EventEmitter';
import { mix } from 'core/mixwith';
import EventCatcherMixin from 'mixins/EventCatcher';

/**
 * This is a description of the SocialLogin constructor function.
 * @class
 * @classdesc This is a description of the SocialLogin class.
 * @extends Component
 */
export default class SocialShare extends mix(Component).with(EventCatcherMixin) {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {Object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            provider: '',
            height: 300,
            width: 500,
            scrollbars: 'yes',
            resizable: 'yes',
        }, options));
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        super.bindEvents();

        on('click', this.element, this.open.bind(this));
    }

    /**
     * Open social share
     * @param {HTMLElement} e - social share element to be opened
     */
    open(e) {
        e.preventDefault();

        const url = this.element.getAttribute('href');
        const top = window.innerHeight / 2 - (this.options.height / 2);
        const left = window.innerWidth / 2 - (this.options.width / 2);
        const params = `height=${this.options.height},
                        width=${this.options.width},
                        scrollbars=${this.options.scrollbars},
                        resizable=${this.options.resizable},
                        top=${top},
                        left=${left}`;

        const newWindow = window.open(url, this.options.provider, params);

        if (newWindow && window.focus) {
            newWindow.focus();
        }

        if (this.analytics) {
            Event.emit('analytics.event', this.analytics);
        }
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        off('click', this.element);
    }
}
